module.exports = __webpack_public_path__ + "img/school_xjsdfz.bb925212.png";